"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRecord = void 0;
const react_1 = require("react");
const record_1 = require("../model/record");
const context_1 = require("../context");
const use_meta_1 = require("./use_meta");
const model_1 = require("../model");
const react_redux_1 = require("react-redux");
const store_1 = require("../store");
function useRecord(param1, param2) {
    const context = (0, react_1.useContext)(context_1.WidgetContext);
    const hasDatasheet = param1 instanceof model_1.Datasheet;
    const { datasheetId: metaDatasheetId } = (0, use_meta_1.useMeta)();
    const datasheetId = hasDatasheet ? param1.datasheetId : metaDatasheetId;
    const recordId = hasDatasheet ? param2 : param1;
    const hasRecord = (0, react_redux_1.useSelector)(state => {
        var _a;
        if (!datasheetId || !recordId) {
            return false;
        }
        return (_a = (0, store_1.getWidgetDatasheet)(state, datasheetId)) === null || _a === void 0 ? void 0 : _a.snapshot.recordMap[recordId];
    });
    return (0, react_1.useMemo)(() => {
        if (!hasRecord)
            return;
        return new record_1.Record(datasheetId, context, recordId);
    }, [datasheetId, recordId, context, hasRecord]);
}
exports.useRecord = useRecord;
